//import _ from 'lodash';

export default function FaultsViewEditRowDirective() {
  return {
    template: require('./edit.html'),
    transclude: true,
    restrict: 'E',
    scope: {},
    controller: EditFaultFormController,
    controllerAs: 'vm',
    bindToController: {
      fault: '=',
      copiedFault: '=',
      isEditPage: '=',
      editFault: '&',
      deleteFault: '&',
      saveFault: '&',
      disableEditMode: '&',
      isDuplicate: '&',
    },
  };

  function EditFaultFormController($stateParams, faultsService) {
    'ngInject';

    var vm = this;
    //var existingFault = {};
    //var configurationId = $stateParams.configurationId;
    vm.faultOptions = [];

    //Public Functions
    vm.cancelEdit = cancelEdit;
    vm.save = save;
    vm.removeIsDuplicateError = removeIsDuplicateError;
    vm.processing = false;

    function init() {
      //let existingFault = _.clone(vm.fault);
      vm.faultOptions = faultsService.getFaultOptions();
    }
    init();

    function cancelEdit() {
      if (vm.fault.isNew) {
        vm.deleteFault(vm.fault);
      } else {
        resetFault();
        vm.disableEditMode();
      }
    }

    function resetFault() {
      vm.fault.type = vm.copiedFault.type;
      vm.fault.code = vm.copiedFault.code;
      vm.fault.priority = vm.copiedFault.priority;
      vm.fault.autoClear = vm.copiedFault.autoClear;
      vm.fault.notifyOnReturn = vm.copiedFault.notifyOnReturn;
    }

    function removeIsDuplicateError() {
      vm.editForm.$setValidity('duplicate', true);
      vm.editForm.spn.$setValidity('duplicate', true);
      vm.editForm.fmi.$setValidity('duplicate', true);
      vm.editForm.source.$setValidity('duplicate', true);
    }

    function save() {
      vm.editForm.$submitted = true;

      if (vm.isDuplicate()) {
        vm.editForm.$setValidity('duplicate', false);
        vm.editForm.spn.$setValidity('duplicate', false);
        vm.editForm.fmi.$setValidity('duplicate', false);
        vm.editForm.source.$setValidity('duplicate', false);
      } else if (vm.editForm.$valid) {
        vm.processing = true;
        vm.saveFault().then(function () {
          vm.disableEditMode();
        });
      }
    }
  }
}
